// import React, { useEffect, useState } from 'react'

const PracticeDetailsPrintPopup = ({ data }) => {
    // const formatAddress = (data) => {
    // // Format >>>>> Address,City
    // // >>>>>>>>>>>> State,Zip

    //     if (!data) return "";

    //     const { PracticeAddress, PracticeCity, PracticeState, PracticeZipCode } = data;
    //     const partsTop = [PracticeAddress, PracticeCity].filter(Boolean).join(", ");
    //     const partsBottom = [PracticeState, PracticeZipCode].filter(Boolean).join(", ");

    //     if (!partsTop && !partsBottom) return "";

    //     // Add <br /> only if there's something in top section (address or city)
    //     return partsTop ? `${partsTop}<br />${partsBottom}` : partsBottom;
    // };
    const formatAddress = (data) => {
        // Format >>>>> Address
        // >>>>>>>>>>>> City, State ZIP

        if (!data) return "";

        const { PracticeAddress, PracticeCity, PracticeState, PracticeZipCode } = data;

        // First line → Address
        const line1 = PracticeAddress || "";

        // Second line → City, State ZIP
        const cityStateZip = [PracticeCity, [PracticeState, PracticeZipCode].filter(Boolean).join(" ")].filter(Boolean).join(", ");

        // Combine with line break if both exist
        if (line1 && cityStateZip) return `${line1}<br />${cityStateZip}`;
        return line1 || cityStateZip || "";
    };
    const address = formatAddress(data);

    // const [imageBase64, setImageBase64] = useState("");
    // // ✅ Fetch and convert image to Base64
    // useEffect(() => {
    //     if(!data?.PracticeImage) return;
    //     const getBase64ImageFromUrl = async (url) => {
    //         if (!url) return "";
    //         try {
    //             const res = await fetch(url, { mode: "cors" });
    //             const blob = await res.blob();
    //             return new Promise((resolve) => {
    //             const reader = new FileReader();
    //             reader.onloadend = () => resolve(reader.result);
    //             reader.readAsDataURL(blob);
    //             });
    //         } catch (err) {
    //             console.error("Failed to load image", err);
    //             return "";
    //         }
    //     };

    //     (async () => {
    //     const base64 = await getBase64ImageFromUrl(data?.PracticeImage);
    //         setImageBase64(base64);
    //     })();
    // }, [data?.PracticeImage]);
    const formatFax = (fax) => {
        if (!fax) return "";
        const cleaned = fax.replace(/\D/g, "");     // remove non-numeric
        if (cleaned.length !== 10) return fax;      // return original if invalid

        return cleaned.replace(/(\d{3})(\d{3})(\d{4})/, "$1-$2-$3");
    };
    const formatPhone = (num) => {
        if (!num) return "";
        const digits = num.replace(/\D/g, ""); // keep only numbers
        if (digits.length !== 10) return num;  // invalid → return original

        return digits.replace(/(\d{3})(\d{3})(\d{4})/, "($1) $2-$3");
    };
    return (
        <>
            <div className="">
                <img src={data?.PracticeImage} alt="" className="practice-img" crossOrigin="anonymous" />
            </div>
            <div className="text-center">
                <p className='heading validate-color fs-14'>{data?.PracticeName || 'N/A'}</p>
                {address && (
                    <p
                        className="text text-black"
                        dangerouslySetInnerHTML={{ __html: address }}
                    />
                )}

            </div>
            <div className="d-flex gap-10">
                <div className="">
                    <p className='text text-black font-m pb-2px'>Tel:</p>
                    <p className='text text-black font-m'>Fax:</p>
                </div>
                <div className="">
                    <p className='text text-black  pb-2px'>{formatPhone(data?.PracticeTelephone) || 'N/A'}</p>
                    <p className='text text-black '>{formatFax(data?.PracticeFax) || 'N/A'}</p>
                </div>
            </div>
        </>
    )
}

export default PracticeDetailsPrintPopup